/**
 * Monitors focus events on the Chat Interface's text areas, and
 * ensures that the chat stays in view and usaable on mobile-phone browsers.
 *
 *   - "mobile" == Capabilities.isMobile()
 *   - Because we're on "mobile" browsers, we don't support IE
 *   - Because we're on "mobile" browsers, we don't consider persistent chat.
 */
/**
 * package: com.inq.flash.client.chatskins
 * class: ChatTextFocusMonitor
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplVodafoneAppIos = function() {
    com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase.call(this); // Call superclass's constructor.
};
$hxClasses.extend(com.inq.flash.client.chatskins.ChatTextFocusMonitorImplBase,
                  com.inq.flash.client.chatskins.ChatTextFocusMonitorImplVodafoneAppIos,
                  "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplVodafoneAppIos"
                 );

/**
 * resizeToViewportVodafoneIos
 * Resize the chat so that it fills the viewport.
 *
 * This is what we want to do:
 *	 Use innerHeight for the viewport height for this application only
 *
 * @private
 * @param {string}  from
 * @return {void}
 */
com.inq.flash.client.chatskins.ChatTextFocusMonitorImplVodafoneAppIos.prototype.resizeToViewport = function(from) {
    // If chat is minimized, I do not want to resize chat.
	if(this.bResizeToViewport
	   || com.inq.flash.client.control.MinimizeManager.minimized)
		return;

	this.bResizeToViewport = true;
	/** @type {Window} */
	var clientWin = window.top;

    // if its a device with a virtual keyboard and we are responding to focus event ( on a text input ).. we are resizing to make room for keybd
	this.zoomViewport(clientWin);
	com.inq.flash.client.chatskins.ScrollMonitor.bindAll();
	try {
		viewPort = com.inq.utils.Capabilities.getViewport();
		/**
		 * In landscape availHeight return the portrait height
		 */
		if(this.hasFocus || !com.inq.utils.Capabilities.getOrientation()) {
		    /* fpinn says: The commented code below is there for a fall back strategy if this code does not work */
		    //	viewPort.h = clientWin.screen.availHeight - ((com.inq.utils.Capabilities.getOrientation()) ? com.inq.flash.client.chatskins.ChatTextFocusMonitor.SAFARI_KEYBOARD_HEIGHT_PORTRAIT : com.inq.flash.client.chatskins.ChatTextFocusMonitor.SAFARI_KEYBOARD_HEIGHT_LANDSCAPE) ;
			viewPort.h = clientWin.innerHeight;
		} else {
			viewPort.h = clientWin.screen.availHeight;
		}
		Application.SetArea(viewPort);
		Application.Resize();
		this.bResizeToViewport = false;
		if (this.hasFocus) {
			com.inq.utils.Timer.delay(function () {
				com.inq.flash.client.chatskins.SkinControl.cw.scrollToEnd();
			}, 100);
		}
	} catch (err) {
		haxe.Log.trace("Error: " + err, { fileName : "ChatTextFocusMonitorImplVodafoneApplos.js", lineNumber : 59, className : "com.inq.flash.client.chatskins.ChatTextFocusMonitorImplVodafoneAppIos", methodName : "resizeToViewport"});
		this.bResizeToViewport = false;
	}
};

com.inq.flash.client.chatskins.ChatTextFocusMonitorImplVodafoneAppIos.prototype.onBlurImpl = function(ev) {

	var stage = com.inq.ui.Stage.getInstance();
	var stageIsVisible = stage.getVisible();
	var clientWin = window.parent;
	if (stageIsVisible) {
		clientWin.scrollTo(0, 0);
	}
	this.onBlurHandlerPhoneIphone();
	return true;
};




